<template>
  <div class="home">
    <div class="main">

      <transition name="fade">
        <div v-if="loading" class="loader">

          <!--        <div class="spinner">-->
          <!--          <img class="loading-gif" src="@/assets/images/loading.gif" alt="">-->
          <!--          <h1 v-text="loadingPercentage"></h1>-->
          <!--        </div>-->

          <img alt="" class="logo" src="@/assets/images/refill-now-logo.png">

          <div class="water"></div>
        </div>
      </transition>

      <div class="menu">
        <!--
        <div class="menu__item menu__item--list"
             @click='geoLocate()'>
        </div>
        -->

        <div
          class="menu__item menu__item--lang"
          :class="['menu__item--lang-' + this.$root.$i18n.locale]"
          @click="showLanguageMenu()"
        ></div>

        <div
          class="menu__item menu__item--filters"
          @click="showFilters()"
        ></div>

        <div
          class="menu__item menu__item--locate"
          @click="geoLocate()"></div>

        <a
          class="menu__item menu__item--add"
          :href="$t('community-url')"
          target="_blank"
        >
        </a>
      </div>

      <language-menu
        :is-open="languageMenuVisible"
        :langs="langs"
        @hideLanguageMenu="hideLanguageMenu"></language-menu>

      <location-filters :is-open="filtersVisible"></location-filters>

      <location-thumbnail
        :is-open="thumbnailVisible"
        :marker="activeMarker"
        :walking-distance="activeMarkerWalkingDistance"
        @showDetails="showDetails"
      >
      </location-thumbnail>

      <location-detail
        :is-open="detailsVisible"
        :marker="activeMarker"
        :walking-distance="activeMarkerWalkingDistance"
        @hideDetails="hideDetails"
      >
      </location-detail>

      <GMap
        ref="map"
        @hideLoading="hideLoading"
        @hideThumbnails="hideThumbnails"
        @loadingProgress="loadingProgress"
        @setWalkingDistance="setWalkingDistance"
        @showFilters="showFilters"
        @showThumbnail="showThumbnail"
      />

      <div class="footer">
        <a href="https://www.refill-now.com" target="_top"
        ><img alt="" src="@/assets/images/logo_small.svg"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import LocationThumbnail from '../components/LocationThumbnail'
import LocationDetail from '../components/LocationDetail'
import LocationFilters from '../components/LocationFilters'
import LanguageMenu from '../components/LanguageMenu'
import GMap from '../components/Map'
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'Home',
  components: {
    LanguageMenu,
    LocationThumbnail,
    LocationDetail,
    LocationFilters,
    GMap
  },
  data () {
    return {
      thumbnailVisible: false,
      detailsVisible: false,
      filtersVisible: false,
      languageMenuVisible: false,
      activeMarker: {},
      activeMarkerWalkingDistance: '',
      loading: true,
      langs: [
        {
          short: 'en',
          long: 'English'
        },
        {
          short: 'it',
          long: 'Italiano'
        },
        {
          short: 'es',
          long: 'Espanol'
        },
        {
          short: 'nl',
          long: 'Nederlands'
        },
        {
          short: 'fr',
          long: 'Français'
        }
      ]
    }
  },
  computed: {
    google: gmapApi
  },
  methods: {
    showLanguageMenu: function () {
      this.languageMenuVisible = true
    },
    showThumbnail: function ({ marker, index }) {
      this.activeMarker = marker
      this.thumbnailVisible = true
      this.detailsVisible = false
      this.filtersVisible = false
    },

    hideThumbnails () {
      this.thumbnailVisible = false
      this.detailsVisible = false
      this.filtersVisible = false
    },

    showFilters () {
      this.filtersVisible = !this.filtersVisible
      this.thumbnailVisible = false
      this.detailsVisible = false
    },
    showDetails () {
      this.thumbnailVisible = false
      this.detailsVisible = true
      this.filtersVisible = false
    },
    hideDetails () {
      this.detailsVisible = false
    },
    hideLanguageMenu () {
      this.languageMenuVisible = false
    },
    setWalkingDistance (walkingDistance) {
      this.activeMarkerWalkingDistance = walkingDistance.walkingDistance // No idea why this is?
    },
    geoLocate () {
      this.$refs.map.geoLocate()
    },
    hideLoading () {
      this.loading = false
    },
    loadingProgress (data) {
      this.loadingPercentage = data.progress

      document.querySelector('.water').style.width = this.loadingPercentage
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.loader {
  position: fixed;
  z-index: 9000001;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  transition: all 500ms;
  background-color: rgba(255, 255, 255, 0.99);

  .water {
    position: absolute;
    z-index: 20;
    bottom: 0;
    left: 0;
    width: 0;
    height: 5px;
    transition: width 300ms;
    background: #293171;
  }

  .spinner {
    position: relative;
    width: 100px;
    height: 100px;
  }

  h1 {
    font-size: 18px;
    font-weight: 300;
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    margin: 0;
    padding: 0;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #293171;
  }

  .loading-gif {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .logo {
    width: 90%;
    max-width: 300px;
    margin-bottom: 10px;
  }
}

body,
html,
#app {
  height: 100%;
}

.marker {
  cursor: pointer;
}

.home {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  height: 100%; /* Fallback for browsers that do not support Custom Properties */
}

.main {
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vue-map-container {
  z-index: 5;
}

// Cluster background image
.cluster img {
  width: 100%;
  height: 100%;
}

// Icons
.menu {
  position: absolute;
  z-index: 999;
  top: 15px;
  right: 10px;
  display: flex;
  flex-direction: column;
}

.menu__item {
  display: block;
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 200ms;
  border-radius: 50%;
  background-color: white;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 20px 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 10px;

  &:hover,
  &:active,
  &:focus {
    box-shadow: rgba(0, 0, 0, 0.5) 0 1px 5px;
  }

  &--locate {
    background-image: url("~@/assets/icons/geolocate.svg");
  }

  &--filters {
    background-image: url("~@/assets/icons/filters.svg");
  }

  &--list {
    background-image: url("~@/assets/icons/list.svg");
  }

  &--add {
    background-image: url("~@/assets/icons/add_location.svg");
  }

  &--lang {
    background-size: 100% 100%;
    background-image: url("~@/assets/images/flags/it.svg");
    position: relative;
    display: flex;
    border: 3px solid white;

    &::before {
      content: 'Buongiorno!';
      display: block;
      font-weight: bold;
      align-self: center;
      white-space: nowrap;
      transform: translateX(-115%);
      animation: fadeout 1500ms forwards;
      animation-delay: 5000ms;
    }
  }

  &--lang-es {
    background-image: url("~@/assets/images/flags/es.svg");

    &::before {
      content: 'Buenos dias!';
    }
  }

  &--lang-it {
    background-image: url("~@/assets/images/flags/it.svg");

    &::before {
      content: 'Buongiorno!';
    }
  }

  &--lang-en {
    background-image: url("~@/assets/images/flags/en.svg");

    &::before {
      content: 'Hello!';
    }
  }

  &--lang-de {
    background-image: url("~@/assets/images/flags/de.svg");

    &::before {
      content: 'Guten Tag!';
    }
  }

  &--lang-fr {
    background-image: url("~@/assets/images/flags/fr.svg");

    &::before {
      content: 'Bonjour!';
    }
  }

  &--lang-nl {
    background-image: url("~@/assets/images/flags/nl.svg");

    &::before {
      content: 'Goeiedag!';
    }
  }
}

.footer {
  position: absolute;
  z-index: 5;
  top: 5px;
  left: 5px;
  align-items: center;
  height: 40px;
  padding-left: 5px;

  img {
    height: 100%;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1000ms;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

</style>
